/* eslint-disable no-console */
/* eslint-disable no-new */
import { isProd } from 'config/config';
import { API, getOrders } from 'helpers/api';
import { formatDate, formatMoney } from 'helpers/utils';

import Vue from 'vue/dist/vue';
import Vuex from 'vuex/dist/vuex';

import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css';
import format from 'date-fns/format';

const orderHistoryEl = document.querySelector('#order-history');
if (orderHistoryEl) {
    Vue.use(AirbnbStyleDatepicker, {
        sundayFirst: true,
        colors: {
            selected: '#ea7200',
            inRange: '#ea7200',
            inRangeBorder: '#ea7200',
            hoveredInRange: '#ff810a',
        },
    });
    Vue.use(Vuex);

    const orderHistory = new Vuex.Store({
        state: {
            response: {},
            isLoading: true,
            dates: {
                startDate: '',
                endDate: '',
            },
            maximumOrders: 250,
            currentPage: 1,
            paginationInput: 1,
        },
        mutations: {
            setSearchDate(state, payload) {
                const startDate = new Date(payload.dateOne + 'T06:00:00.000Z');
                const endDate = new Date(payload.dateTwo + 'T06:00:00.000Z');

                function formatDates(monthOrDate) {
                    return monthOrDate < 10 ? '0' + monthOrDate : '' + monthOrDate;
                }

                state.dates.startDate = `${startDate.getFullYear()}-${formatDates(
                    startDate.getMonth() + 1,
                )}-${formatDates(startDate.getDate())}`;
                state.dates.endDate = `${endDate.getFullYear()}-${formatDates(
                    endDate.getMonth() + 1,
                )}-${formatDates(endDate.getDate())}`;
            },
            setCurrentPage(state, payload) {
                state.currentPage = payload;
            },
            setPaginationInput(state, payload) {
                state.paginationInput = payload;
            },
        },
        actions: {
            async GetOrders(context) {
                const res = await API.orders.history.get(
                    context.state.dates.startDate,
                    context.state.dates.endDate,
                    context.state.maximumOrders,
                );

                if (!res.error) {
                    context.state.response = res;
                    context.state.dates.startDate = res.SearchOrderDateStart;
                    context.state.dates.endDate = res.SearchOrderDateEnd;

                    context.state.currentPage = 1;
                    context.state.paginationInput = 1;
                }

                context.state.isLoading = false;
            },
        },
    });

    Vue.component('calendar', {
        template: '#calendar',
        data() {
            return {
                dateFormat: 'M/D/YYYY',
            };
        },
        computed: {
            dates: {
                get() {
                    return {
                        dateOne: orderHistory.state.dates.startDate,
                        dateTwo: orderHistory.state.dates.endDate,
                    };
                },
            },
        },
        methods: {
            formatDates(dateOne, dateTwo) {
                let formattedDates = '';
                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat);
                }
                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat);
                }
                return formattedDates;
            },
            updateDates() {
                orderHistory.commit('setSearchDate', this.dates);
                orderHistory.dispatch('GetOrders');
            },
        },
    });
    new Vue({
        el: '#order-history',
        orderHistory,
        data: {
            searchFilter: '',
            pageSize: 20,
        },
        computed: {
            isProd() {
                return isProd;
            },
            isLoading() {
                return orderHistory.state.isLoading;
            },
            filteredOrders() {
                if (orderHistory.state.response.orders) {
                    return orderHistory.state.response.orders.filter((order) => {
                        return (
                            order.invoiceNumber.match(this.searchFilter) ||
                            order.customerPurchaseOrderNumber
                                .toLowerCase()
                                .match(this.searchFilter.toLowerCase())
                        );
                    });
                }
                return [];
            },
            dashboardOrders() {
                if (orderHistory.state.response.orders) {
                    return orderHistory.state.response.orders.slice(0, 5);
                }
                return [];
            },
            currentPage: {
                get() {
                    return orderHistory.state.currentPage;
                },
                set(newPage) {
                    orderHistory.commit('setCurrentPage', newPage);
                },
            },
            paginationInput: {
                get() {
                    return orderHistory.state.paginationInput;
                },
                set(newPage) {
                    orderHistory.commit('setPaginationInput', newPage);
                },
            },
            disablePreviousLink() {
                return this.currentPage <= 1;
            },
            disableNextLink() {
                return this.currentPage >= this.totalNumOfPages;
            },
            visibleOrders() {
                console.log(this.filteredOrders);
                return this.filteredOrders.slice(
                    (this.currentPage - 1) * this.pageSize,
                    (this.currentPage - 1) * this.pageSize + this.pageSize,
                );
            },
            totalNumOfPages() {
                const filledPages = Math.floor(this.filteredOrders.length / this.pageSize);
                const remainder = this.filteredOrders.length % this.pageSize;

                if (remainder) {
                    return filledPages + 1;
                }
                return filledPages;
            },
            visibleOrdersLow() {
                if (!this.filteredOrders.length) {
                    return 0;
                }
                return this.pageSize * this.currentPage - (this.pageSize - 1);
            },
            visibleOrdersHigh() {
                if (this.currentPage == this.totalNumOfPages) {
                    return this.filteredOrders.length;
                }
                return this.currentPage * this.pageSize;
            },
        },
        filters: {
            formatDate(date) {
                return formatDate(date);
            },
            formatMoney(price) {
                return formatMoney(price);
            },
            formatOrderDetailsURL(order) {
                const link = isProd ? '/portal/order-details' : '/order-details.html';
                return link + '?orderNumber=' + order;
            },
            getStatus(statusCode) {
                switch (statusCode) {
                    case '1210':
                        return 'Cancelled';
                    case '1211':
                        return 'In Process';
                    case '1212':
                        return 'Credit Memo';
                    case '1214':
                        return 'RMA';
                    case '1215':
                        return 'Open-Quote';
                    case '1216':
                        return 'Backordered';
                    case '1217':
                        return 'Future Delivery';
                    default:
                        return 'Shipped';
                }
            },
        },
        methods: {
            previousPage() {
                this.currentPage -= 1;
                this.paginationInput = this.currentPage;
            },
            nextPage() {
                this.currentPage += 1;
                this.paginationInput = this.currentPage;
            },
            validatePaginationInput() {
                if (this.paginationInput === '') {
                } else if (
                    isNaN(this.paginationInput) ||
                    this.paginationInput > this.totalNumOfPages ||
                    this.paginationInput <= 0
                ) {
                    this.paginationInput = this.currentPage;
                } else {
                    const input = parseInt(this.paginationInput);
                    this.currentPage = input;
                    this.paginationInput = input;
                }
            },
            refreshPage() {
                if (this.filteredOrders.length) {
                    this.currentPage = 1;
                    this.paginationInput = 1;
                } else {
                }
            },
        },
        mounted() {
            orderHistory.dispatch('GetOrders');
        },
    });
}

// ====================================================================================================
// ====================================================================================================
// ====================================================================================================
// ====================================================================================================
// Copy of pre-Vue order-history.js. Kept in-tact to keep mini Order History module in Dashboard running until it's rewritten in Vue.
// ====================================================================================================
// ====================================================================================================
// ====================================================================================================
// ====================================================================================================

const state = {
    pageGroup: 1,
    pageNum: 1,
    orderCount: 50,
    search: {},
    mini: false,
    href: isProd ? '/portal/order-details' : '/order-details.html',
};

// ==================================================
// INITIALIZERS
// ==================================================

export async function fetchOrders() {
    if (document.getElementsByClassName('js--oh-mini')[0]) {
        state.search = {
            ResultCount: 5,
        };
        state.mini = true;
    }

    const orderType = document
        .getElementsByClassName('js--order-list')[0]
        .getAttribute('data-backorder')
        ? 'backorder'
        : 'order';
    const res =
        orderType === 'backorder'
            ? await getBackOrders(state.search)
            : await getOrders(state.search);
    res.data.Orders = res.data.Orders || [];

    if (state.mini) {
        res.data.Orders = res.data.Orders.slice(0, 5);
    }

    state.orderCount = state.mini ? 5 : res.data.Orders.length;
    updateList(res.data.Orders, orderType);
    if (orderType === 'backorder') {
        Array.from(document.getElementsByClassName('js--bsetainfo')).forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const modal = document.getElementsByClassName('js--pd-modal-bsetainfo')[0];
                toggleModal(modal, true);
            });
        });
    }
}

// // ==================================================
// // HELPERS
// // ==================================================

export function updateList(listItems, orderType = 'orders') {
    state.pageGroup = 1;

    document.getElementsByClassName('js--order-list')[0].innerHTML = !listItems.length
        ? noItems()
        : listItems
              .map((k, i) => (orderType === 'backorder' ? backOrder(k, i) : lineItem(k, i)))
              .join('');
}

function lineItem(
    {
        ShipDate,
        CustomerPurchaseOrderDate: orderDate,
        CustomerPurchaseOrderNumber: po,
        InvoiceNumber: invoice,
        InvoiceAmount: total,
        InvoiceStatusCode: status,
    },
    i,
) {
    const ordered = orderDate && orderDate.length ? formatDate(orderDate) : 'N/A';
    const shipped = ShipDate && ShipDate.length ? formatDate(ShipDate) : 'N/A';
    const hidden = i > 10 ? 'list-grid__results--hidden' : '';

    if (state.mini) {
        return `<li class="module-orders__list__li">
  <ul class="module-orders__sublist">
    <li class="module-orders__sublist__item"><p>${ordered}</p></li>
    <li class="module-orders__sublist__item"><p>${po}</p></li>
    <li class="module-orders__sublist__item"><p>${formatMoney(total)}</p></li>
    <li class="module-orders__sublist__item"><p>${getStatus(status)}</p></li>
  </ul>
</li>`;
    }

    const html = `<li class="js--pagination-page-${state.pageGroup} ${hidden}">
  <a href="${
      state.href
  }?orderNumber=${invoice}" target="_blank" rel="noopener" class="list-grid__results__item list-grid__result-link list-grid__results--link">
      <div class="list-grid__results__li" data-label="Order Date"><p>${ordered}</p></div>
      <div class="list-grid__results__li" data-label="PO #"><p>${po}</p></div>
      <div class="list-grid__results__li" data-label="Invoice #"><p>${invoice}</p></div>
      <div class="list-grid__results__li" data-label="Ship Date"><p>${shipped}</p></div>
      <div class="list-grid__results__li" data-label="Total"><p>${formatMoney(total)}</p></div>
      <div class="list-grid__results__li" data-label="Status"><p>${getStatus(status)}</p></div>
    </a>
  </li>`;

    if (i > 0 && i % 10 === 0) {
        state.pageGroup += 1;
    }

    return html;
}

function backOrder(
    {
        PartNumber,
        OriginalTicketNumber: invoice,
        QuantityBackordered: qty,
        ManufacturerCode: mf,
        StockBackorderEstimatedShipDate: eta,
    },
    i,
) {
    const hidden = i > 10 ? 'list-grid__results--hidden' : '';

    const html = `<li class="js--pagination-page-${state.pageGroup} ${hidden}">
  <a href="${
      state.href
  }?orderNumber=${invoice}" target="_blank" rel="noopener" class="list-grid__results__item list-grid__result-link list-grid__results--link">
      <div class="list-grid__results__li" data-label="QTY"><p>${qty}</p></div>
      <div class="list-grid__results__li" data-label="Mfg Code"><p>${mf}</p></div>
      <div class="list-grid__results__li" data-label="Part #"><p>${PartNumber}</p></div>
      <div class="list-grid__results__li" data-label="ETA"><p>${
          // ** More info button **
          // mf === 'BS'
          //   ? '<button class="btn-info js--bsetainfo"><i class="fas fa-info"></i>&nbsp;More Information</button>'
          //   : eta || 'ETA Currently Unavailable'
          eta ? formatDate(eta) : 'ETA is To Be Determined'
      }</p></div>
    </a>
  </li>`;

    if (i > 0 && i % 10 === 0) {
        state.pageGroup += 1;
    }

    return html;
}

const noItems = () =>
    `<li>
    <div class="list-grid__results__item">
      No items were found.
    </div>
  </li>`;

function getStatus(code) {
    switch (code) {
        case '1210':
            return 'Cancelled';
        case '1211':
            return 'In Process';
        case '1212':
            return 'Credit Memo';
        case '1214':
            return 'RMA';
        case '1215':
            return 'Open-Quote';
        case '1216':
            return 'Back Orders';
        case '1217':
            return 'Future Delivery';
        default:
            return 'Shipped';
    }
}

// ==================================================
// INIT
// ==================================================

async function init() {
    await fetchOrders();
    if (!document.getElementsByClassName('js--oh-mini')[0]) {
        paginationList({
            start: true,
            orderCount: state.orderCount,
        });
    }
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/order-history.js